export default __webpack_public_path__ + "static/media/ea-dropdown.30d54424.webp";